import {
    getCheckautoCompanyAllListRequest,
    getCompanyAllListRequest,
    getCompanyAllRequest,
} from '../../../../services/network/company/all';

class CommonCompanyAllService {
    async getCompanyAllList(payload) {
        return await getCompanyAllListRequest(payload);
    }

    async getCompanyAll(id) {
        return await getCompanyAllRequest(id);
    }

    async getCheckautoCompanyAllList(payload) {
        return await getCheckautoCompanyAllListRequest(payload);
    }
}

export const CompanyAllService = new CommonCompanyAllService();
